exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.simpleCard{border-radius:10px!important}.simpleCard>div{padding-bottom:0!important}.simpleCard__title{padding:20px 28px 16px!important;border-top-left-radius:10px;border-top-right-radius:10px;font-size:18px;color:#fff;background-color:#0288d1}.simpleCard__title>div{display:none!important}.simpleCard__body{padding:12px 8px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/simpleCard.scss
// module id = 954
// module chunks = 0